import Axios from 'axios'
import store from '../store'

export default {
  getClientId () {
    return store.getters['Client/clientId']
  },
  getServicesDesk () {
    return Axios.get(`api/external/clients/${this.getClientId()}/servicedesks/services`)
  },
  getServiceRequests (date) {
    return Axios.get(`api/internal/clients/${this.getClientId()}/events/servicedesk?date=${date}`)
  },
  getSuppliers () {
    return Axios.get(`api/internal/clients/${this.getClientId()}/servicedesks/suppliers/names`)
  },
  saveServicesDesk (serviceDeskRequest, extendedPropertiesId) {
    return Axios.put(`api/internal/clients/${this.getClientId()}/events/${extendedPropertiesId}/servicedesk`, serviceDeskRequest)
  },
  getReport (start, end) {
    let headers = {responseType: 'arraybuffer'}
    return Axios.get(`api/internal/clients/${this.getClientId()}/servicedesks/reports/file?start=${start}&end=${end}`, headers)
  },
  getAuditLogServicesDesk (extendedPropertiesId) {
    return Axios.get(`/api/internal/clients/${this.getClientId()}/events/servicedesk/${extendedPropertiesId}/audit`)
  },
  saveSuppliers (services, extendedPropertiesId){
    return Axios.put(`api/internal/clients/${this.getClientId()}/events/${extendedPropertiesId}/servicedesk/suppliers`, services)
  }
}
